export const stock_coreValues = [
  {
    country: 'Japan',
    company: [
      'Yamato',
      'Dōmo arigatō',
      'Seikō',
      'Sakura no kuni',
      'Japan Motor',
    ],
    time: 50,
    risk: 5,
    amount: 100,
    price: 210,
  },
  {
    country: 'Canada',
    company: ['Maple Inc.', 'Polar Bear', 'Favor & kindness', 'Sure, eh'],
    time: 3,
    risk: 7,
    amount: 100,
    price: 269,
  },
  {
    country: 'Brazil',
    company: [
      'Avião Pequeno',
      'Minha linda',
      'Big Brasil',
      'Rio',
      'São Paulo',
      'São Salvador',
    ],
    time: 20,
    risk: 11,
    amount: 200,
    price: 223,
  },
  {
    country: 'Germany',
    company: [
      'Teile GmbH',
      'Bayern GmbH',
      'Berliner Bären',
      'Hafen von Hamburg',
      'Ruhrgebiet',
      'der Kebap',
      'Achtung',
    ],
    time: 31,
    risk: 2,
    amount: 300,
    price: 231,
  },
  {
    country: 'China',
    company: [
      'Best Friend',
      'My Corp',
      'Big Brother',
      'Red Dragon',
      'Fàn',
      'Good Quality',
      'Moon Shanzung',
    ],
    time: 65,
    risk: 18,
    amount: 500,
    price: 165,
  },
  {
    country: 'Australia',
    company: ['Yello Kangaroo', 'Upside down', 'Desert & Ocean', 'Long road'],
    time: 90,
    risk: 7,
    amount: 250,
    price: 189,
  },
  {
    country: 'Russia',
    company: [
      'Matryoshka',
      'Vodka & more',
      'Hot Sibir',
      'Vladimir',
      'Da da da',
    ],
    time: 36,
    risk: 13,
    amount: 300,
    price: 201,
  },
  {
    country: 'Cameroon',
    company: ['Africa Power', 'Future', 'New Quality', 'Bénoué River'],
    time: 40,
    risk: 11,
    amount: 150,
    price: 201,
  },
  {
    country: 'Chile',
    company: [
      'Atakama Factory',
      'Cerro Azul',
      'Copper & more',
      'Chilenismos corp.',
      'Completo italiano',
    ],
    time: 22,
    risk: 9,
    amount: 350,
    price: 225,
  },
  {
    country: 'Colombia',
    company: [
      'Emerald Inc.',
      'La Arenosa',
      'Sucursal del Cielo',
      'Aguardiente',
    ],
    time: 5,
    risk: 13,
    amount: 200,
    price: 246,
  },
  {
    country: 'Finland',
    company: [
      'Hot Sauna',
      'Metsä Power',
      'Järvi corp.',
      'Joulupukki',
      'Muumit Work & Travel',
    ],
    time: 28,
    risk: 7,
    amount: 100,
    price: 226,
  },
  {
    country: 'France',
    company: ['Paris Parts', 'Merci', 'Grenouille et Escargot', 'Usine à Lyon'],
    time: 31,
    risk: 4,
    amount: 200,
    price: 226,
  },
  {
    country: 'Italy',
    company: ['Pizza & Pasta', 'Colosseum', 'Roma', 'San Mario', 'Fuoco'],
    time: 35,
    risk: 5,
    amount: 150,
    price: 220,
  },
  {
    country: 'Jamaica',
    company: ['Jam', 'Reggae Stytle', 'Kingston', 'MyTime'],
    time: 18,
    risk: 15,
    amount: 50,
    price: 215,
  },
  {
    country: 'Korea',
    company: ['Hangul Factory', 'Aegyo', 'Samsong Inc.', 'New Gangnam'],
    time: 55,
    risk: 7,
    amount: 200,
    price: 202,
  },
  {
    country: 'Poland',
    company: [
      'Wawel Dragon',
      'Warsaw mermaid',
      'Solidarność',
      'Potato and vodka',
      'Hussars',
    ],
    time: 33,
    risk: 9,
    amount: 150,
    price: 213,
  },
];
